// The video someone asked for before paying for it, kept across the trip to Stripe.
//
// Since 2026-10-27 a new account has no free AI video: it writes its idea, presses Generate and
// meets the first-video offer (components/upgrade/FirstVideoOffer.jsx). The offer promises that the
// video starts by itself once they have paid, so the idea and every choice go into this browser
// before checkout, and the AI Agent page makes the video when they are back with a video to spend.
// `paid` is set by whoever sees the payment: the pack's confirm (growth/CheckoutComeback.jsx) or
// the subscription's success page. A checkout left at Stripe brings them back with the form as it
// was, and nothing starts.
const KEY = 'pending_first_video';
// A checkout takes minutes; a kept video older than this belongs to another visit
const FRESH_MS = 2 * 60 * 60 * 1000;
export const PAID_EVENT = 'pending-video-paid';

export function keepPendingVideo(form, now = Date.now()) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ form, at: now, paid: false }));
  } catch {
    // A private window: they come back to their idea (utils/ideaDraft.js) and press Generate again
  }
}

/** The kept video if it is fresh: {form, at, paid}, else null. */
export function readPendingVideo(now = Date.now()) {
  try {
    const kept = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    if (!kept?.form || !kept.at || now - kept.at > FRESH_MS) return null;
    return kept;
  } catch {
    return null;
  }
}

export function markPendingVideoPaid() {
  const kept = readPendingVideo();
  if (!kept) return false;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ ...kept, paid: true }));
    window.dispatchEvent(new Event(PAID_EVENT));
  } catch {
    return false;
  }
  return true;
}

export function clearPendingVideo() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // nothing kept
  }
}

// The first-video offer opened again for someone back from a Pro checkout they left (?checkout=left):
// once a visit
const LEFT_PRO = 'first_video_offer_pro_left';

export function leftProOfferShown() {
  try {
    return window.sessionStorage.getItem(LEFT_PRO) === '1';
  } catch {
    return false;
  }
}

export function markLeftProOfferShown() {
  try {
    window.sessionStorage.setItem(LEFT_PRO, '1');
  } catch {
    // a private window: shown again on the next return, which is rare
  }
}
